import axios from "../axiosPlugin.js";

export const getMonthlyClosingList = (data = {}, loading = true, isDefaultAlertTips = true) => {
  // const _data = Object.keys(data).map(key => `${key}=${data[key]}`).join("&");
  return axios({
    url: "/api/monthClose/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const createMonthClosing = (all = false, data = {}) => {
  const url = all ? "/api/monthClose/create?all=ALL" : "/api/monthClose/create";
  return axios({
    url: url,
    method: "post",
    data: { data },
  });
};

export const approveMonthClosing = (loading = false, isDefaultAlertTips = false) => {
  return axios({
    url: "/api/monthClose/approve",
    method: "get",
    data: {
      loading,
      isDefaultAlertTips
    },
  });
};

export const deleteMonthClosing = (data, loading = false, isDefaultAlertTips = false) => {
  const _data = Object.keys(data).map(key => `${key}=${data[key]}`).join("&");
  return axios({
    url: `/api/monthClose/delete?${_data}`,
    method: "get",
    data: {
      loading,
      isDefaultAlertTips,
    },
  });

};